import { ViewName } from "@ms/uno-constants/lib/local/ViewConstants";
/**
 * Registry of all tracked interactions — EVO-native views only.
 * Adding a new tracked interaction requires only adding an entry here
 * and wiring a `startInteraction(name)` call at the click site.
 */ export const TrackedInteractions = {
    // Navigation — AC dispatches route/modal change → different component renders
    OpenTaskEditor: {
        completionStrategy: "viewRender",
        viewName: ViewName.TaskEditorContainer
    },
    // Grid — Sort column click → grid re-renders with sorted data → last visible row renders
    GridSort: {
        completionStrategy: "manual",
        viewName: ViewName.GridPage
    },
    // Grid — Filter applied → grid re-renders with filtered data → visible rows settle
    GridFilter: {
        completionStrategy: "manual",
        viewName: ViewName.GridPage
    },
    // Grid — Paste tasks (copy- or cut-paste) → AC creates/updates tasks → grid repaints with new rows
    GridPasteTasks: {
        completionStrategy: "manual",
        viewName: ViewName.GridPage
    },
    // Grid — Bulk field update (multi-select context menu) → AC updates N tasks → grid repaints
    GridBulkUpdate: {
        completionStrategy: "manual",
        viewName: ViewName.GridPage
    },
    // Grid — Delete one or more tasks → AC removes tasks → grid repaints with rows gone
    GridDeleteRows: {
        completionStrategy: "manual",
        viewName: ViewName.GridPage
    },
    // Catalyst — FAB click opens Copilot pane → pane renders with initial state
    OpenCatalystPane: {
        completionStrategy: "viewRender",
        viewName: ViewName.PlannerCopilotPane
    }
};
